"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
// TODO - This button had a view_works check, but presumably that's already been checked by the point they get here - we should reinvestigate when we add songwriter permissions
const CatalogExportButton = (props) => {
    const { catalogSearchStore, loading, setSidebarIsOpen } = props;
    return (react_1.default.createElement(Button_1.Button, { submitType: 'button', mainColor: true, type: "secondary", className: "export-search-button", disabled: !catalogSearchStore.isSearchExportable || loading, onClick: () => setSidebarIsOpen(true) }, "Export"));
};
exports.default = CatalogExportButton;
